module.exports = __webpack_public_path__ + "static/media/mausam - cold wave.f9e1da7c.png";